import { render } from "./cartBtn.vue?vue&type=template&id=a36f2da0&scoped=true&ts=true"
import script from "./cartBtn.vue?vue&type=script&lang=ts"
export * from "./cartBtn.vue?vue&type=script&lang=ts"

import "./cartBtn.vue?vue&type=style&index=0&id=a36f2da0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36f2da0"]])

export default __exports__